import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { pumpEnergySources } from '../DataSets';

const PumpEnergySource = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      id="energySource"
      name="energySource"
      items={pumpEnergySources}
      label="Pump Energy Source"
      disabled={!isEnableInfoTabEdit}
      placeholder="Select pump energy source"
    />
  );
};

export default PumpEnergySource;
